export enum LifecycleCategories {
	KosherEvaluation = 1,
	FacilityIngredient = 2,
}
